import React from 'react';
import {
  Visa,
  MasterCard,
  Paypal,
  Sofort,
  PaymentTransfer,
} from './components';

import styles from './styles/mobile.module.scss';

const PaymentMobile = () => (
  <div className={styles.container}>
    <div className={styles.block}>
      <Visa className={styles.visa} />
      <MasterCard className={styles.mastercard} />
      <Paypal className={styles.paypal} />
      <Sofort className={styles.sofort} />
      <PaymentTransfer className={styles.vorkasse} />
    </div>
  </div>
);

PaymentMobile.displayName = 'Payment';

export default PaymentMobile;
